import {BaseContainerModel} from "../../base-container.model";
import {
  bl_wf_issue_comment_hdr_RowInterface,
  bl_wf_issue_comment_hdr_RowClass,
  bl_wf_issue_comment_ext_RowClass
} from "../../../dbschema";

export class WfIssueCommentContainerModel extends BaseContainerModel {
  bl_wf_issue_comment_hdr: bl_wf_issue_comment_hdr_RowInterface = new bl_wf_issue_comment_hdr_RowClass();
  bl_wf_issue_comment_ext: bl_wf_issue_comment_ext_RowClass[] = [];
}
